/**
 * Bundle Sale Pricing - SIMPLE VERSION
 * Updates bundle pricing and Add to Cart button during sales
 */

console.log('[BUNDLE] 📦 bundle_sale_pricing.js loaded');

const DEBUG_BUNDLE = window.HH_DEBUG_MODE || false;

function bundleLog(...args) {
  if (DEBUG_BUNDLE) console.log('[BUNDLE]', ...args);
}

// Read cart-tier config
function getConfig() {
  try {
    const el = document.getElementById('cart-tiers-config');
    if (el?.textContent) {
      const parsed = JSON.parse(el.textContent.trim());
      return Array.isArray(parsed) ? { tiers: parsed } : parsed;
    }
  } catch (e) {
    console.warn('[BUNDLE] Config parse error:', e);
  }
  return null;
}

// Get tier for prospective cart total
function getTier(prospectiveCents, tiers) {
  const rate = window.Shopify?.currency?.rate || 1;
  const dollars = prospectiveCents / 100;
  let tier = tiers[0];

  for (const t of tiers) {
    // Parse as numbers (metaobject fields come as strings)
    const threshold = parseFloat(t.threshold) || 0;
    if (dollars >= threshold * rate) tier = t;
  }

  // Ensure rate is a number
  tier.rate = parseFloat(tier.rate) || 0;

  return tier;
}

// Format money properly with correct currency symbol
function fmt(cents) {
  const { locale } = window.Shopify;
  const { active: currency } = window.Shopify.currency;
  const decimalValue = cents / 100;

  // Use Intl.NumberFormat for proper currency formatting
  return new Intl.NumberFormat(locale || 'en-US', {
    style: "currency",
    currency: currency,
    currencyDisplay: "symbol",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(decimalValue);
}

// Main update function
async function updateBundlePricing() {
  console.log('[BUNDLE] 🚀 updateBundlePricing() called');
  bundleLog('Updating bundle pricing...');

  const dataEl = document.getElementById('bundle-product-pricing-data');
  if (!dataEl) {
    console.log('[BUNDLE] ❌ bundle-product-pricing-data element not found');
    return;
  }
  console.log('[BUNDLE] ✅ Found bundle-product-pricing-data element');

  let rawData;
  try {
    rawData = JSON.parse(dataEl.textContent);
    bundleLog('RAW product data from Liquid:', rawData);
  } catch (e) {
    console.error('[BUNDLE] JSON parse error on bundle-product-pricing-data:', e);
    console.error('[BUNDLE] Raw text:', dataEl.textContent);
    return;
  }

  const { price, compareAtPrice, displayDiscount, bundleConfig, saleConfig } = rawData;

  // Get config from either cart-tiers-config OR saleConfig in bundle data
  const config = getConfig() || saleConfig;
  bundleLog('Config source:', config ? (getConfig() ? 'cart-tiers-config' : 'saleConfig') : 'NONE');
  bundleLog('Config data:', config);

  if (!config) {
    bundleLog('No sale config found - skipping bundle pricing');
    return;
  }

  // Check if active (handle both boolean and string "true")
  const isActive = config.active === true || config.active === "true";
  if (!isActive) {
    bundleLog('Sale config exists but not active - skipping');
    return;
  }
  const activeCurrency = window.Shopify?.currency?.active;

  // Check if bundle config is active (handle both boolean and string)
  if (bundleConfig) {
    const bundleConfigActive = bundleConfig.active === true || bundleConfig.active === "true";
    if (!bundleConfigActive) {
      bundleLog('⚠️ Bundle config exists but is INACTIVE - skipping bundle pricing');
      return;
    }
  }

  // CHECK FOR PRODUCT-SPECIFIC DISPLAY DISCOUNT (overrides tier system)
  if (displayDiscount && displayDiscount.enabled) {
    bundleLog('🎯 DISPLAY DISCOUNT DETECTED - Ignoring tier system');
    bundleLog('Display discount config:', displayDiscount);

    // Use Shopify Markets converted price (already in active currency)
    // Then apply the display_discount RATE to the Markets price
    const marketsPriceCents = price; // Already in active currency (e.g., $556 CAD = 55600 cents)
    const discountRate = parseFloat(displayDiscount.rate); // e.g., 0.5 for 50%

    // Apply discount rate to Markets price
    const finalPriceCents = Math.round(marketsPriceCents * (1 - discountRate));
    const compareAtCents = marketsPriceCents; // Original Markets price
    const savingsCents = compareAtCents - finalPriceCents;

    bundleLog('====== DISPLAY DISCOUNT (Markets Currency) ======');
    bundleLog('Markets price (cents):', marketsPriceCents);
    bundleLog('Discount rate:', discountRate);
    bundleLog('Final price (cents):', finalPriceCents);
    bundleLog('Compare-at (cents):', compareAtCents);
    bundleLog('Savings (cents):', savingsCents);
    bundleLog('Percentage:', displayDiscount.percentage_label);
    bundleLog('===================================================');

    // Format prices using Shopify currency (already converted by Markets)
    const finalPriceFormatted = fmt(finalPriceCents);
    const compareAtFormatted = fmt(compareAtCents);
    const savingsFormatted = fmt(savingsCents);

    // Get display settings from bundleConfig (outside container block for button access)
    const container = document.getElementById('bundle-sale-pricing-container');
    const showBanner = bundleConfig ? bundleConfig.showBanner : (container?.dataset.showBanner === 'true');
    const bannerIcon = bundleConfig?.bannerIcon || container?.dataset.bannerIcon || '🔥';
    const bannerPrefix = bundleConfig?.bannerPrefix || container?.dataset.bannerPrefix || 'FLASH SALE:';
    const bannerSuffix = bundleConfig?.bannerSuffix || container?.dataset.bannerSuffix || 'on this bundle';
    const buttonTextStyle = bundleConfig?.buttonTextStyle || container?.dataset.buttonText || 'default';

    // Update display (using Shopify Markets currency)
    if (container) {
      // Set data attributes for gift widget (needs both price and compare-at)
      container.setAttribute('data-price', finalPriceCents);
      container.setAttribute('data-compare-at-price', compareAtCents);

      let html = `
        <div class="simple-price-flex">
          <div class="bundle-simple-price" data-price="${finalPriceCents}">
            <span class="money">${finalPriceFormatted}</span>
          </div>
          <span class="compare-strike">
            <span class="money">${compareAtFormatted}</span>
          </span>
        </div>
        <div class="bundle-savings-line">
          You save: ${displayDiscount.percentage_label} (<span class="money">${savingsFormatted}</span>)
        </div>
      `;

      if (showBanner) {
        html += `
          <div class="bundle-savings-banner">
            ${bannerIcon} ${bannerPrefix} ${displayDiscount.percentage_label} ${bannerSuffix}
          </div>
        `;
      }

      container.innerHTML = html;
    }

    // Update button
    const button = document.querySelector('.bundle-atc');
    if (button) {
      if (buttonTextStyle === 'discount') {
        button.textContent = `Claim ${displayDiscount.percentage_label} Now`;
      } else if (buttonTextStyle === 'price') {
        button.innerHTML = `Add to Cart - <span class="money">${finalPriceFormatted}</span>`;
      } else if (buttonTextStyle === 'savings') {
        button.innerHTML = `Save <span class="money">${savingsFormatted}</span> - Add to Cart`;
      }
    }

    bundleLog('✅ Display discount applied with Shopify Markets currency');
    return; // Exit early - don't run tier calculation
  }

  // NORMAL TIER-BASED PRICING (no display discount)
  bundleLog('Using tier-based pricing (no display_discount metafield)');
  bundleLog('Price:', price, 'cents');
  bundleLog('Compare-at:', compareAtPrice, 'cents');

  // Get cart
  let cart = 0;
  try {
    if (window.fetchCartSubtotalCents) {
      cart = await window.fetchCartSubtotalCents();
    } else {
      const res = await fetch(window.Shopify.routes.root + 'cart.js');
      const data = await res.json();
      cart = data.original_total_price || data.total_price || 0;
    }
  } catch (e) {
    bundleLog('Cart fetch error:', e);
  }

  // Calculate
  const prospective = cart + price;
  const tier = getTier(prospective, config.tiers);

  bundleLog('====== TIER CALCULATION ======');
  bundleLog('Cart subtotal:', cart, 'cents');
  bundleLog('Bundle price:', price, 'cents');
  bundleLog('Prospective total:', prospective, 'cents');
  bundleLog('Selected tier:', tier);

  const finalPrice = Math.round(price * (1 - tier.rate));
  const totalSavings = compareAtPrice - finalPrice;
  const totalPercent = Math.round((totalSavings / compareAtPrice) * 100);

  bundleLog('Final price:', finalPrice, 'cents', '=', fmt(finalPrice));
  bundleLog('Total savings:', totalSavings, 'cents', '=', fmt(totalSavings));
  bundleLog('Total %:', totalPercent + '%');
  bundleLog('============================');

  // Update price display
  const container = document.getElementById('bundle-sale-pricing-container');
  if (container) {
    // Use bundleConfig if available, otherwise fall back to data attributes
    const showBanner = bundleConfig ? bundleConfig.showBanner : (container.dataset.showBanner === 'true');
    const bannerIcon = bundleConfig?.bannerIcon || container.dataset.bannerIcon || '🔥';
    const bannerPrefix = bundleConfig?.bannerPrefix || container.dataset.bannerPrefix || 'FLASH SALE:';
    const bannerSuffix = bundleConfig?.bannerSuffix || container.dataset.bannerSuffix || 'on this bundle';
    const buttonTextStyle = bundleConfig?.buttonTextStyle || container.dataset.buttonText || 'default';

    // Set data-price attribute for gift widget
    container.setAttribute('data-price', finalPrice);

    let html = `
      <div class="simple-price-flex">
        <div class="bundle-simple-price" data-price="${finalPrice}">${fmt(finalPrice)}</div>
        <span class="compare-strike">${fmt(compareAtPrice)}</span>
      </div>
      <div class="bundle-savings-line">
        You save: ${totalPercent}% (${fmt(totalSavings)})
      </div>
    `;

    if (showBanner) {
      // Format: "🔥 FLASH SALE: Save £91.11 (39%) on this bundle"
      html += `
        <div class="bundle-savings-banner">
          ${bannerIcon} ${bannerPrefix} Save ${fmt(totalSavings)} (${totalPercent}%) ${bannerSuffix}
        </div>
      `;
    }

    container.innerHTML = html;
  }

  // Update button - check for both old and new button structures
  let button = document.querySelector('.button--add-to-cart .text');
  let priceSpan = document.querySelector('.price_cta');
  let savingsSpan = document.querySelector('.price_savings');

  // Use bundleConfig button style
  const buttonText = bundleConfig?.buttonTextStyle || container?.dataset.buttonText || 'default';

  if (button) {
    // Old button structure
    if (buttonText === 'discount') {
      button.textContent = `Claim ${totalPercent}% Now`;
    } else if (buttonText === 'price') {
      button.textContent = `Add to Cart - ${fmt(finalPrice)}`;
    } else if (buttonText === 'savings') {
      button.textContent = `Save ${fmt(totalSavings)} - Add to Cart`;
    }
  } else if (priceSpan && savingsSpan) {
    // New buy-buttons.liquid structure
    priceSpan.textContent = fmt(finalPrice);
    priceSpan.style.cssText = 'color: #ffffff !important; font-weight: bold !important;';

    if (buttonText === 'discount' || buttonText === 'savings') {
      savingsSpan.textContent = `YOU'RE SAVING ${fmt(totalSavings)}`;
      savingsSpan.style.cssText = 'color: #ffffff !important; font-weight: bold !important;';
      savingsSpan.classList.remove('hidden');
    }
  }

  bundleLog('✅ Updated');
}

// Init
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', updateBundlePricing);
} else {
  updateBundlePricing();
}

// Cart updates
document.addEventListener('cartDataIntercepted', updateBundlePricing);
window.updateBundlePricing = updateBundlePricing;
